export const STEP_FAMILY_TYPE = 1
export const STEP_MAIN_BIRTHDAY_DATE = 2
export const STEP_MAIN_JOB = 3
export const STEP_MAIN_AGRICULTURAL_STATUS = 4
export const STEP_MAIN_ZIPCODE = 5

export const STEP_PARTNER_BIRTHDAY_DATE = 6
export const STEP_PARTNER_JOB = 7

export const STEP_CHILDREN_COUNT = 8
export const STEP_CHILDREN_1 = 9
export const STEP_CHILDREN_2 = 10
export const STEP_CHILDREN_3 = 11
export const STEP_CHILDREN_4 = 12
export const STEP_CHILDREN_5 = 13

export const STEP_EFFECTIVE_DATE = 14
export const STEP_CONTRACT = 15
export const STEP_NEEDS = 16
export const STEP_INFOS = 17
